import React from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem
} from '@chakra-ui/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const HistoryItem = ({ template, onView, onComplete, onUpdate, onDownload, idx, bid }) => {
  return (
    <Box
      key={`to-complete-${template._id}`}
      borderWidth="1px"
      borderRadius="lg"
      mb={4}
      width="100%"
      className="actionableItem"
    >
      <Flex direction="column" p={4} justify="space-between" height="100%">
        <Flex justify="space-between" align="right" textAlign="left">
          <Box>
            <Text fontSize="sm">
              Title: <b>{template?.name}</b>
            </Text>
            <Text fontSize="sm">
              {"Requested on"}:{" "}
              <b>{moment(template.conversation_created).format("MMMM Do YYYY, h:mm:ss a")}</b>
            </Text>
            {template.business_name && <Text fontSize="sm" fontWeight="bold">{template.business_name}</Text>}
          </Box>
          <Flex alignItems="center" gap={4}>
            {template.completed ? (
              <Button onClick={() => onView(template)}>
                View Completed Questionnaire
              </Button>
            ) : (
              <Button onClick={() => onComplete(template)}>
                Complete the Questionnaire
              </Button>
            )}
            <Flex>
              {template.completed && (
                <Menu direction={"flex-end"}>
                  <MenuButton
                    as={IconButton}
                    aria-label="Options"
                    icon={<FontAwesomeIcon icon={faEllipsisV} />}
                    variant="ellipsis"
                  />
                  <MenuList>
                    {template?.enabled?.[bid] && (
                      <MenuItem
                        id={`edit-${idx}`}
                        onClick={() => onUpdate(template)}
                      >
                        Update
                      </MenuItem>
                    )}
                    <MenuItem id={`dnl-${idx}`} onClick={() => onDownload(template)}>
                      Download as PDF
                    </MenuItem>
                  </MenuList>
                </Menu>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default HistoryItem;
